/** Hosts which are excluded from having the comments bubble appear */

export default [
    '0f55d425-672f-419b-8b54-007e54113a1c',
];